// import DashboardAxios from "axios";
import Vuex, { mapActions } from "vuex";
import ribbon from "./stores/ribbon";
import phonebook from "./stores/phonebook";
import money from "./Mony.json";
import VueOffline from "vue-offline";
import modal from "./plugins/EasyModal/index";
import i18n from "./plugins/EasyModal/i18n";
import { setLanguageCookie } from "./utils/languageCookie";
import axiosLib from "axios";
import { ir } from "./check_domain_ir";
const axios = axiosLib.default || axiosLib;
let timer = null;

export default {
  install(Vue, options) {
    Vue.use(Vuex);
    Vue.use(VueOffline);
    Vue.use(modal);

    if (!options.store.hasModule("ribbon")) {
      options.store.registerModule("ribbon", ribbon);
    }
    if (!options.store.hasModule("phonebook")) {
      options.store.registerModule("phonebook", phonebook);
    }
    const rootAxios =
      options.axios && typeof options.axios.create === "function"
        ? options.axios
        : axios;
    Vue.prototype.$instanceAxios = options.axios;
    Vue.prototype.$DashboardAxios = axios.create({
      baseURL: ir(options.core_url),
      timeout: 60000,
      headers: {
        common: options.headers,
      },
    });
    Vue.prototype.$payamakAxios = rootAxios.create({
      baseURL: Vue.prototype.$payamakApi,
      timeout: 60000,
      headers: options.headers,
    });

    Vue.mixin({
      data: () => ({
        core_url: options.core_url,
        DHeaders: options.headers,
        front_url: options.front_url,
        DConfigs: options.config(),
        sid: options.sid,
      }),
      methods: {
        ...mapActions("ribbon", ["setWallet"]),
        changeLanguage(lang) {
           if (typeof options.onChangeLanguage === 'function') {
            options.onChangeLanguage(lang);
          }
          i18n.locale = lang;
          setLanguageCookie(lang);
        },
        setSubTitle(title) {
          store.state.sub_title = title;
        },
        ribbon_can(permission) {
          const abilities = options.permissions();

          return (
            abilities.indexOf(permission + ":active") >= 0 ||
            abilities.indexOf(permission + ":show") >= 0
          );
        },
        persianNum(input) {
          if (i18n.locale !== "fa") return input.toLocaleString();

          try {
            if (input === undefined || input == null) return "";
            let str1 = input.toString().trim();
            if (str1 === "") return "";
            str1 = str1.replace(/0/gim, "۰");
            str1 = str1.replace(/1/gim, "۱");
            str1 = str1.replace(/2/gim, "۲");
            str1 = str1.replace(/3/gim, "۳");
            str1 = str1.replace(/4/gim, "۴");
            str1 = str1.replace(/5/gim, "۵");
            str1 = str1.replace(/6/gim, "۶");
            str1 = str1.replace(/7/gim, "۷");
            str1 = str1.replace(/8/gim, "۸");
            str1 = str1.replace(/9/gim, "۹");
            return str1;
          } catch (e) {}
        },
        currency(x) {
          try {
            return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          } catch (e) {
            return x;
          }
        },
        setWalletData(data) {
          let walletInfo = money.data[data.currency.toLowerCase()];
          let user_wallet = {
            icon: walletInfo.icon,
            color: walletInfo.color,
            balance: data.balance,
          };
          this.setWallet(user_wallet);
          localStorage.setItem("user_wallet", JSON.stringify(user_wallet));
        },
        setCookie(cname, cvalue, exdays) {
          let d = new Date();
          d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
          let expires = "expires=" + d.toUTCString();
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        getCookie(cname, def = "") {
          let name = cname + "=";
          let decodedCookie = decodeURIComponent(document.cookie);
          let ca = decodedCookie.split(";");
          for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") {
              c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
              return c.substring(name.length, c.length);
            }
          }
          return def;
        },
        setToken() {
          let url = window.location.href;
          const start = url.indexOf("?");
          const end = url.indexOf("#");
          url = url.substring(start, end);
          let token = url.split("=")[0];
          let dataToken = url.split("=")[1];
          if (dataToken) {
            saveToken(dataToken);
            // this.$store.commit('isAuthenticated', true);
            return document.URL.substr(end);
          }
          return false;
        },
        debounce: (fn, delay) => debounce(fn, delay),
        hasPhonebookPermission(value, target = null) {
          let p;

          if (!!target)
            p = this.isInShareListPhonebook(target) ? target.setting : true;
          else p = options.store.getters["phonebook/phonebookPermissions"];

          return typeof p === "object" ? p[value] : true;
        },
        isInShareListPhonebook(target) {
          return target.hasOwnProperty("parent_id");
        },
        datetime(input, type, utc = false) {
          if (!input) return "-";

          if (type === "datetime") {
            return `${this.jalalian(input)} ${this.getTime(input)}`;
          } else {
            return `${this.jalalian(input)}`;
          }
        },
        copyLink(str, isLink = true, message = null) {
          let link = str;

          if (!link.startsWith("http") && isLink) link = "https://" + link;

          try {
            if (!!navigator.clipboard) navigator.clipboard.writeText(link);
            else {
              let textArea = document.createElement("textarea");
              textArea.value = link;

              // Avoid scrolling to bottom
              textArea.style.top = "0";
              textArea.style.left = "0";
              textArea.style.position = "fixed";

              document.body.appendChild(textArea);
              textArea.focus();
              textArea.select();

              try {
                let successful = document.execCommand("copy");
                let msg = successful ? "successful" : "unsuccessful";
              } catch (err) {
                this.$toast.error("خطا در رونوشت لینک.");
              }

              document.body.removeChild(textArea);
            }
          } catch (e) {
            this.$toast.error("خطا در رونوشت لینک.");
          }

          this.$toast.info(message || "لینک کپی شد.");
        },
        goto(route, query = {}) {
          this.$router.push({ path: "/" + route, query: query });
        },
        nowDateTimeString(sp = "-") {
          let moment = require("moment-jalaali");
          return moment().format(`YYYY${sp}MM${sp}DD HH:mm:ss`);
        },
      },
    });

    Array.prototype.removeDuplicateInArray = function (target) {
      const uniqueTags = new Map(this.map((item) => [item[target], item]));
      return [...uniqueTags.values()];
    };

    window.ribbonCan = (permission) => {
      if (!permission) return true;

      const abilities = options.permissions();

      return (
        abilities.indexOf(permission + ":active") >= 0 ||
        abilities.indexOf(permission + ":show") >= 0
      );
    };
  },
};

function debounce(fn, delay) {
  clearTimeout(timer);

  timer = setTimeout(fn, delay);
}

export { debounce };
